<ng-container>
  <fieldset>
    <legend>
      <div>
        <span i18n>Blueprints</span>
      </div>
    </legend>
    <table>
      @for (blueprintControl of blueprintsFormArray.controls; track blueprintControl; let blueprintIndex = $index) {
        <tr [formGroup]="toFormGroup(blueprintControl)">
          <td>
            <div class="form-container">
              <mat-form-field appearance="outline">
                <mat-label i18n>Blueprint</mat-label>
                <mat-select id="blueprint-id" formControlName="id">
                  @for (option of blueprintNamesWithCategoryNames; track option) {
                    <mat-option [value]="option.id">
                      {{ option.name }}
                    </mat-option>
                  }
                </mat-select>
              </mat-form-field>
            </div>
          </td>
          <td>
            <div class="form-container">
              <mat-form-field appearance="outline">
                <mat-label i18n>Value</mat-label>
                <mat-select id="blueprint-categories" multiple formControlName="categories">
                  @for (option of getCategoryNamesForBlueprint(toFormGroup(blueprintControl).value.id); track option) {
                    <mat-option [value]="option.id" [title]="option.name">
                      {{ option.name }}
                    </mat-option>
                  }
                </mat-select>
              </mat-form-field>
            </div>
          </td>
          <td>
            <button mat-icon-button
              aria-label="Delete blueprint"
              i18n-aria-label
              (click)="onDelete(blueprintIndex)">
              <mat-icon inline>delete</mat-icon>
            </button>
          </td>
        </tr>
      }
    </table>

    <button mat-stroked-button (click)="onAdd()" i18n>Add blueprint</button>
  </fieldset>
</ng-container>
